<template>
  <div class="row" v-show="checkPermission">
    <div>
      서버 상태:
      <span style="font-weight:bold;margin:0px 2px 0px 5px"
        :style="{color: state.healthCheck.refresh ? 'black' : state.healthCheck.alive == true ? '#33AA33' : '#CC3333'}"
      >
        {{state.healthCheck.refresh ? '' : state.healthCheck.alive == true ? 'alive' : 'dead'}}
        <q-tooltip content-class="bg-indigo">
          {{state.healthCheck.refreshTime}}
        </q-tooltip>
      </span>
    </div>
    <q-btn v-if="state.healthCheck.refresh == false" dense flat icon="refresh" size="sm" @click="listen__healthcheck__onclick" >
      <q-tooltip>새로고침</q-tooltip>
    </q-btn>
    <q-spinner-audio v-else
      color="primary"
      size="2em"
    />
  </div>
</template>

<script>
import MISC from '@/js/miscellaneous.js'
import ETC from '@/js/etc.js'

export default {
  props: ['functionKey', 'functionCheck', 'recognizeName'],
  data: function () {
    return {
      state: {
        healthCheck: {
          refresh: false,
          refreshTime: '',
          alive: false,
          address: ''
        }
      }
    }
  },
  methods: {
    listen__healthcheck__onclick: async function () {
      const Vue = this
      Vue.state.healthCheck.refresh = true
      MISC.doubleRaf(async () => {
        let ret
        try {
          if (Vue.functionKey == undefined)
            ret = await Vue.functionCheck(null)
          else {
            const functionKey = Vue.functionKey.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); })
            ret = await Vue.functionCheck[functionKey](null)
          }
        } catch (e) {
          console.log(e)
          ret = {
            alive: false
          }
        }
        Vue.state.healthCheck.refresh = false
        Vue.state.healthCheck.alive = ret.alive
        Vue.state.healthCheck.refreshTime = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split('.')[0].replace('T', ' ')
        Vue.state.healthCheck.address = ret.address
      })
    },
    getAddress: function() {
      return this.state.healthCheck.address
    }
  },
  computed: {
    checkPermission() {
      const Vue = this
      if (ETC.isDev())
        return true
      if (undefined != Vue.recognizeName)
        return Vue.$store.state.user.permission.some(x => x.includes(Vue.recognizeName))
      return true
    }
  }
}
</script>
